<template>
  <div>
    <content-loader v-for="i in 3" :key="i" :height="130" :width="300">
      <rect x="0" y="0" width="300" height="4" />
      <rect x="0" y="48" width="300" height="4" />
      <rect x="0" y="0" width="4" height="50" />
      <rect x="296" y="0" width="4" height="50" />

      <circle cx="25" cy="25" r="18" />
      <rect x="50" y="16" width="40" height="5" />
      <rect x="50" y="24" width="40" height="5" />

      <rect x="0" y="60" width="100" height="5" />
      <rect x="0" y="67" width="60" height="5" />
      <rect x="0" y="80" width="300" height="20" />
    </content-loader>
  </div>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
